import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { FaChevronUp, FaHeart } from 'react-icons/fa';

// Type-casting a react-icons miatt (TS2786 hiba elkerülése)
const UpIcon = FaChevronUp as any;
const HeartIcon = FaHeart as any;

const Footer: React.FC = () => {
  const [showScroll, setShowScroll] = useState(false);

  // Görgetés figyelése a gomb megjelenítéséhez
  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, [showScroll]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Box 
      sx={{ 
        bgcolor: 'primary.dark', // A kért sötétkék háttér
        py: { xs: 10, md: 15 }, // Megnövelt padding a szellősebb hatásért
        textAlign: 'center', 
        position: 'relative',
        color: '#ffffff', // Alapértelmezett fehér szöveg
      }}
    >
      {/* Betűtípus importálása inline a Great Vibes számára */}
      <link href="https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap" rel="stylesheet" />
      
      {/* FŐ TARTALOM (Az image_0.png képen látható szöveges elrendezés) */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 3, md: 5 }, alignItems: 'center' }}>
        
        {/* Név: Alex & Diane (Nagy méretű, kalligrafikus, arany) */}
        <Typography 
          variant="h2" 
          sx={{ 
           // fontFamily: '"Great Vibes", cursive', // Kalligrafikus betűtípus
            fontSize: { xs: '3.5rem', md: '5.5rem' }, // Nagy méret
            color: '#fff', // Arany szín a sötétkék háttéren
            fontWeight: 400,
            lineHeight: 1,
            mb: 0 // Kisebb térköz
          }}
        >
          Meli & Máté
        </Typography>

        {/* Dátum: November 22, 2026 (Sans-serif, arany) */}
        <Typography 
          variant="body1" 
          sx={{ 
            color: '#fff', // Arany szín
            letterSpacing: 2,
            textTransform: 'uppercase', // Nagybetűs
            fontSize: '0.9rem',
            mb: 0 // Kisebb térköz
          }}
        >
         2026. Augusztus 21.
        </Typography>

        <Typography 
          variant="body2" 
          sx={{ 
            color: 'text.secondary', // Halvány bézs
            fontSize: '15px', 
            display: 'flex', alignItems: 'center', gap: 1 // Ikon elhelyezése
          }}
        >
          Mi már nagyon várjuk! <HeartIcon size={18} color="#ffffff" /> 
        </Typography>

        {/* Hashtag (Kicsi, arany) */}
        <Typography 
          variant="caption" 
          sx={{ 
            
            color: '#fff',
            fontSize: '12px', 
            letterSpacing: 1
          }}
        >
          #Meli&Mate2026
        </Typography>
      </Box>

      {/* FUNKCIONÁLIS GOMB (Görgetéskor jelenik meg) */}
      {/* A képen nincs gomb, ezért csak akkor jelenik meg, ha már lejjebb pörgetett */}
      <IconButton 
        onClick={scrollToTop}
        sx={{ 
          position: 'absolute', // Abszolút pozíció
          top: 30, // Fent
          right: 30, // Jobb sarok
          bgcolor: '#ffffff', // Arany szín
          color: 'primary.main', // Fehér ikon
          opacity: showScroll ? 1 : 0,
          visibility: showScroll ? 'visible' : 'hidden',
          transition: 'all 0.3s ease-in-out',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.4)',
          '&:hover': { bgcolor: '#cfcfcf' }
        }}
      >
        <UpIcon size={20} />
      </IconButton>

    </Box>
  );
};

export default Footer;